<template>
  <footer class="bg-dark text-white pt-16 pb-8">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="grid grid-cols-1 lg:grid-cols-4 gap-8 mb-12">
        <!-- 平台信息 -->
        <div class="lg:col-span-1">
          <div class="flex items-center mb-6">
            <div class="w-10 h-10 rounded-lg bg-white flex items-center justify-center">
              <i class="fa-solid fa-graduation-cap text-primary text-xl"></i>
            </div>
            <span class="ml-3 text-xl font-bold text-white">良知技能人才平台</span>
          </div>
          <p class="text-gray-400 mb-6">专业的技能培训、就业指导、证书服务一体化平台，助您实现职业目标</p>
          <div class="flex space-x-4">
            <div class="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
              <i class="fa-brands fa-weixin text-white"></i>
            </div>
            <div class="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
              <i class="fa-brands fa-weibo text-white"></i>
            </div>
            <div class="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
              <i class="fa-brands fa-qq text-white"></i>
            </div>
          </div>
        </div>
        
        <!-- 快速链接和帮助中心/联系我们 (在手机端并排显示) -->
        <div class="grid grid-cols-2 gap-6 lg:col-span-2">
          <div>
            <h3 class="text-lg font-semibold mb-6">快速链接</h3>
            <ul class="space-y-3">
              <li><router-link to="/courses" class="text-gray-400 hover:text-white transition-custom">课程培训</router-link></li>
              <li><a href="https://www.rongyuezhiya.com/" target="_blank" rel="noopener noreferrer" class="text-gray-400 hover:text-white transition-custom">就业创业</a></li>
              <li><router-link to="/certificate" class="text-gray-400 hover:text-white transition-custom">证书鉴别</router-link></li>
              <li><router-link to="/talent" class="text-gray-400 hover:text-white transition-custom">人才入库</router-link></li>
              <li><router-link to="/exams" class="text-gray-400 hover:text-white transition-custom">证书考试</router-link></li>
            </ul>
          </div>
          <div>
            <h3 class="text-lg font-semibold mb-6 lg:hidden">联系我们</h3>
            <h3 class="text-lg font-semibold mb-6 hidden lg:block">帮助中心</h3>
            <ul class="space-y-3">
              <!-- 移动端显示联系我们按钮 -->
              <li v-if="!isDesktop">
                <span 
                  @click="showContactModal = true" 
                  class="text-gray-400 hover:text-white transition-custom cursor-pointer flex items-center"
                >
                  <i class="fa-solid fa-headphones mr-2"></i>联系客服
                </span>
              </li>
              <!-- 桌面端显示帮助中心链接 -->
              <li v-for="item in helpTypes" :key="item.key" v-show="isDesktop">
                <router-link 
                  :to="`/help?type=${item.key}`" 
                  class="text-gray-400 hover:text-white transition-custom"
                >
                  {{ item.name }}
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        
        <!-- 联系我们 - 仅桌面端显示 -->
        <div class="hidden lg:block lg:col-span-1">
          <h3 class="text-lg font-semibold mb-6">联系我们</h3>
          <ul class="space-y-3">
            <li class="flex items-start">
              <i class="fa-solid fa-location-dot text-primary mt-1 mr-3"></i>
              <span class="text-gray-400">考点:河南新质机考研发中心</span>
            </li>
            <li class="flex items-start">
              <i class="fa-solid fa-building text-primary mt-1 mr-3"></i>
              <span class="text-gray-400">报名:河南省科学院能源研究102室</span>
            </li>
            <li class="flex items-center">
              <i class="fa-solid fa-phone text-primary mr-3"></i>
              <span class="text-gray-400">18037137966</span>
            </li>
            <li class="flex items-center">
              <i class="fa-solid fa-clock text-primary mr-3"></i>
              <span class="text-gray-400">周一至周日 9:00-18:00</span>
            </li>
          </ul>
        </div>
      </div>
      <!-- <div class="pt-8 border-t border-white/10 text-center text-gray-500 text-sm">
        <p>© 2023 良知技能人才平台 版权所有 | 京ICP备12345678号</p>
      </div> -->
    </div>

    <!-- 联系我们弹窗 -->
    <div 
      v-if="showContactModal" 
      class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50"
      @click.self="showContactModal = false"
    >
      <div class="bg-white rounded-xl w-full max-w-sm overflow-hidden shadow-2xl">
        <!-- 弹窗头部 -->
        <div class="bg-primary text-white px-6 py-4 flex items-center justify-between">
          <h3 class="text-lg font-semibold">联系我们</h3>
          <button 
            @click="showContactModal = false" 
            class="text-white/80 hover:text-white transition-colors"
          >
            <i class="fa-solid fa-xmark text-lg"></i>
          </button>
        </div>
        <!-- 弹窗内容 -->
        <div class="p-6">
          <ul class="space-y-4">
            <li class="flex items-start">
              <i class="fa-solid fa-location-dot text-primary mt-1 mr-3"></i>
              <span class="text-gray-700">考点:河南新质机考研发中心</span>
            </li>
            <li class="flex items-start">
              <i class="fa-solid fa-building text-primary mt-1 mr-3"></i>
              <span class="text-gray-700">报名:河南省科学院能源研究102室</span>
            </li>
            <li class="flex items-center">
              <i class="fa-solid fa-phone text-primary mr-3"></i>
              <span class="text-gray-700">18037137966</span>
            </li>
            <li class="flex items-center">
              <i class="fa-solid fa-clock text-primary mr-3"></i>
              <span class="text-gray-700">周一至周日 9:00-18:00</span>
            </li>
          </ul>
        </div>
        <!-- 弹窗底部 -->
        <div class="px-6 py-4 bg-gray-50 flex justify-end">
          <button 
            @click="showContactModal = false" 
            class="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors"
          >
            确定
          </button>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { getHelpTypes } from '@/api/index';

export default {
  name: 'Footer',
  data() {
    return {
      helpTypes: [],
      showContactModal: false,
      isDesktop: false
    }
  },
  mounted() {
    this.fetchHelpTypes();
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkDevice);
  },
  methods: {
    checkDevice() {
      this.isDesktop = window.innerWidth >= 1024;
    },
    async fetchHelpTypes() {
      try {
        const res = await getHelpTypes();
        if (res.code === 1 && res.data) {
          this.helpTypes = res.data;
        }
      } catch (error) {
        console.error('获取帮助中心类型失败:', error);
      }
    }
  }
}
</script>

<style lang="less" scoped>
.transition-custom {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
</style> 